import { initializeApp } from "firebase/app";
import {
  getStorage,
  getDownloadURL,
  getMetadata,
  ref,
  uploadBytesResumable,
  deleteObject,
  listAll,
} from "firebase/storage";

import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";

// Init Firebase
const app = initializeApp({
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
});


// Storage
export const storage = {
  firebaseStorage: getStorage(app),
  getDownloadURL,
  getMetadata,
  ref,
  uploadBytesResumable,
  getStorage,
  deleteObject,
  listAll,
};

// Auth
export const auth = getAuth(app);
export const signIn = signInWithEmailAndPassword;
export const signOutUser = signOut;
